<template>
  <svg :width="width" :height="height" viewBox="0 0 22 17" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 16H21" stroke="#006EFF" stroke-width="2" stroke-linecap="round"/>
    <path d="M1 8.5H21" stroke="#006EFF" stroke-width="2" stroke-linecap="round"/>
    <path d="M1 1H21" stroke="#006EFF" stroke-width="2" stroke-linecap="round"/>
  </svg>

</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.textBlueButton }
  },
  name: "IconHamburger"
}
</script>